import {gql} from '@apollo/client';

export const itemDataQueries = {
    GET_ALL_CURSOR_PAGINATION_FOR_SELECT_LIST: gql`
        query ItemDatasWithCursorPagination(
            $after: String
            $first: Int
            $before: String
            $last: Int
            $where: ItemDataFilterInput
            $filters: GetAllItemDataRequestDTOInput
        ) {
            itemDatasWithCursorPagination(
                after: $after
                first: $first
                before: $before
                last: $last
                filters: $filters
                where: $where
            ) {
                totalCount
                edges {
                    cursor
                }
                nodes {
                    id
                    order
                    data {
                        shouldUseAsTheFieldToCreateItem
                        value {
                            value
                        }
                    }
                    url
                    ticketNo
                }
                pageInfo {
                    endCursor
                    hasNextPage
                    hasPreviousPage
                    startCursor
                }
            }
        }
    `,
    GET_ALL_CURSOR_PAGINATION: gql`
        query ItemDatasWithCursorPagination(
            $after: String
            $first: Int
            $before: String
            $last: Int
            $where: ItemDataFilterInput
            $filters: GetAllItemDataRequestDTOInput
        ) {
            itemDatasWithCursorPagination(
                after: $after
                first: $first
                before: $before
                last: $last
                filters: $filters
                where: $where
            ) {
                totalCount
                edges {
                    cursor
                }
                nodes {
                    summaryViews {
                        value
                        uniqueId
                    }
                    active
                    id
                    itemStatus {
                        boardId
                    }
                    isImportedData
                    itemStatusId
                    order
                    data {
                        isMultiValue
                        columnSize
                        defaultValue {
                            options {
                                label
                                value
                                color
                                textColor
                            }
                        }
                        value {
                            value
                            selectedOption {
                                label
                                value
                                color
                                textColor
                            }
                            multiSelectedOptions {
                                label
                                value
                                color
                                textColor
                            }
                            booleanValue
                            integerValue
                        }
                        validationMessage
                        uniqueId
                        fieldCategory
                        fieldType
                        dataType
                        regularExpression
                        title
                        placeHolder
                        helperText
                        isRequired
                        order
                        shouldUseAsTheFieldToCreateItem
                        formula
                        format
                        isReadOnly
                    }
                    url
                    ticketNo
                }
                pageInfo {
                    endCursor
                    hasNextPage
                    hasPreviousPage
                    startCursor
                }
            }
        }
    `,
    GET_ALL_ITEM_DATA_WITH_OUT_PAGINATION: gql`
        query itemDatas($where: ItemDataFilterInput, $filters: GetAllItemDataRequestDTOInput) {
            itemDatas(where: $where, filters: $filters) {
                active
                summaryViews {
                    value
                    uniqueId
                }
                id
                isImportedData
                itemStatusId
                itemStatus {
                    boardId
                }
                data {
                    isMultiValue
                    columnSize
                    defaultValue {
                        options {
                            label
                            value
                            color
                            textColor
                        }
                    }
                    value {
                        value
                        selectedOption {
                            label
                            value
                            color
                            textColor
                        }
                        multiSelectedOptions {
                            label
                            value
                            color
                            textColor
                        }
                        booleanValue
                        integerValue
                    }
                    validationMessage
                    uniqueId
                    fieldCategory
                    fieldType
                    dataType
                    regularExpression
                    title
                    placeHolder
                    helperText
                    isRequired
                    order
                    shouldUseAsTheFieldToCreateItem
                    formula
                    format
                    isReadOnly
                }
                url
                ticketNo
            }
        }
    `,
    GET_ITEM_DATA_BY_TICKET_NO: gql`
        query itemDataByTicketNo($ticketNo: Int!, $boardId: UUID!) {
            oneItemData(where: {ticketNo: {eq: $ticketNo}, itemStatus: {boardId: {eq: $boardId}}}) {
                id
                order
                itemStatusId
                summaryViews {
                    value
                    uniqueId
                }
                sprintId
                ticketNo
                url
                createdDate
                createdByName
                itemStatus {
                    boardId
                }
                data {
                    isMultiValue
                    columnSize
                    defaultValue {
                        options {
                            label
                            value
                            color
                            textColor
                        }
                    }
                    value {
                        value
                        selectedOption {
                            label
                            value
                            color
                            textColor
                        }
                        multiSelectedOptions {
                            label
                            value
                            color
                            textColor
                        }
                        booleanValue
                        integerValue
                    }
                    validationMessage
                    uniqueId
                    fieldCategory
                    fieldType
                    dataType
                    regularExpression
                    title
                    placeHolder
                    helperText
                    isRequired
                    order
                    shouldUseAsTheFieldToCreateItem
                    formula
                    format
                    isReadOnly
                }
            }
        }
    `,
    GET_ITEM_BY_ID: gql`
        query itemById($id: UUID!) {
            oneItemData(where: {id: {eq: $id}}) {
                ticketNo
                url
            }
        }
    `,

    GET_ITEM_DATAS_BY_OFFSET_PAGINATION: gql`
        query GetItemDatasWithOffsetPagination(
            $skip: Int
            $take: Int
            $where: ItemDataFilterInput
            $filters: GetAllItemDataRequestDTOInput
        ) {
            itemDatasWithOffsetPagination(skip: $skip, take: $take, where: $where, filters: $filters) {
                totalCount
                items {
                    summaryViews {
                        value
                        uniqueId
                    }
                    active
                    id
                    sprint {
                        title
                    }
                    isImportedData
                    itemStatusId
                    order
                    data {
                        isMultiValue
                        columnSize
                        defaultValue {
                            options {
                                label
                                value
                                color
                                textColor
                            }
                        }
                        value {
                            value
                            selectedOption {
                                label
                                value
                                color
                                textColor
                            }
                            multiSelectedOptions {
                                label
                                value
                                color
                                textColor
                            }
                            booleanValue
                            integerValue
                        }
                        validationMessage
                        uniqueId
                        fieldCategory
                        fieldType
                        dataType
                        regularExpression
                        title
                        placeHolder
                        helperText
                        isRequired
                        order
                        shouldUseAsTheFieldToCreateItem
                        formula
                        format
                        isReadOnly
                    }
                    url
                    ticketNo
                    itemStatus {
                        title
                    }
                }
                pageInfo {
                    hasNextPage
                    hasPreviousPage
                }
            }
        }
    `,
};
